import { TypedParam } from "./_Base";
import { DecomposedPath } from "../../core/DecomposedPath";
export class TypedPathParam extends TypedParam {
  constructor() {
    super(...arguments);
    this.decomposedPath = new DecomposedPath();
  }
  dispose() {
    this.scene().referencesController.resetReferenceFromParam(this);
    super.dispose();
  }
  _handleReferences(node, path) {
    this.scene().referencesController.setNamedNodesFromParam(this);
    if (node) {
      this.scene().referencesController.setReferenceFromParam(this, node);
    } else {
      this.scene().missingExpressionReferencesController.register(this, path);
    }
  }
}
